import { defineStore } from "pinia";
import { platFormName, tokenName } from "../tokenName";


export interface LoginInfo {
    phone: string,
    password?: string,
    vCode?: string
}


export enum LoginAction {
    CODE="CODE",
    PWD = "PWD"
}

export const useLoginInfo = defineStore('loginInfo', {
    state: () => ({
        phone: '',
        password: '',
        vCode: '',
        platform: Number.isNaN(Number(useCookie(platFormName).value)) ? 2 : Number(useCookie(platFormName).value),
    }),
    actions: {
        updateInfo(loginInfo: LoginInfo) {
            this.phone = loginInfo.phone ?? ''
            this.password = loginInfo.password ?? ''
            this.vCode = loginInfo.vCode ?? '',
            this.platform =  Number.isNaN(Number(useCookie(platFormName).value)) ? 2 : Number(useCookie(platFormName).value)
        },
        initData() {
            // this.phone = '',
            this.password = '',
            this.vCode = ''
        }
    },
    getters: {
        getInfo(): object {
            const result = {
                phone: this.phone,
                password: this.password,
                vCode: this.vCode
            }
            return result
        }
    }
})